import {AnalyticsRoutesEnum} from 'interfaces'
import {DopaminePromptSuggestion} from './DopamineAssistant.types'

type DopamineViewSuggestionConfig = {
  icon: DopaminePromptSuggestion['icon']
  key: string
}

export type DopamineViewConfig = {
  contextKey: string
  introKey: string
  suggestions: readonly DopamineViewSuggestionConfig[]
}

const VIEW_CONFIG = {
  overview: {
    contextKey: 'ANALYTICS_OVERVIEW_CONTEXT',
    introKey: 'DOPAMINE_ANALYTICS_INTRO',
    suggestions: [
      {key: 'TOP_AI_APPS', icon: 'apps'},
      {key: 'SENSITIVE_DATA_TO_AI', icon: 'shield'},
      {key: 'USERS_TO_INVESTIGATE', icon: 'users'},
    ],
  },
  policy: {
    contextKey: 'ANALYTICS_POLICY_CONTEXT',
    introKey: 'DOPAMINE_POLICY_INTRO',
    suggestions: [
      {key: 'MOST_TRIGGERED_POLICY_RULES', icon: 'shield'},
      {key: 'USERS_BYPASSING_AI_POLICY', icon: 'users'},
      {key: 'BLOCKS_BY_APP', icon: 'apps'},
    ],
  },
  shadowIT: {
    contextKey: 'ANALYTICS_SHADOW_IT_CONTEXT',
    introKey: 'DOPAMINE_SHADOW_IT_INTRO',
    suggestions: [
      {key: 'NEW_AI_APPS', icon: 'apps'},
      {key: 'RISKY_UNSANCTIONED_APPS', icon: 'shield'},
      {key: 'AI_AGENTS_AND_MCP', icon: 'apps'},
    ],
  },
} as const satisfies Record<string, DopamineViewConfig>

const GENERIC_ANALYTICS_VIEW_CONFIG = {
  ...VIEW_CONFIG.overview,
  contextKey: 'ANALYTICS_CONTEXT',
} as const satisfies DopamineViewConfig

export const normalizeDopaminePathname = (pathname: string): string => {
  if (pathname.length === 0) return '/'

  let lastPathCharacterIndex = pathname.length - 1

  while (
    lastPathCharacterIndex > 0 &&
    pathname[lastPathCharacterIndex] === '/'
  ) {
    lastPathCharacterIndex -= 1
  }

  return pathname.slice(0, lastPathCharacterIndex + 1).toLowerCase()
}

export const getDopamineViewConfig = (pathname: string): DopamineViewConfig => {
  const normalizedPathname = normalizeDopaminePathname(pathname)

  if (normalizedPathname === AnalyticsRoutesEnum.ANALYTICS_OVERVIEW) {
    return VIEW_CONFIG.overview
  }
  if (normalizedPathname === AnalyticsRoutesEnum.ANALYTICS_POLICY) {
    return VIEW_CONFIG.policy
  }
  if (normalizedPathname === AnalyticsRoutesEnum.ANALYTICS_SHADOW_IT) {
    return VIEW_CONFIG.shadowIT
  }
  return GENERIC_ANALYTICS_VIEW_CONFIG
}
